import {Component, Input, OnInit} from '@angular/core';
import {FormComponent, RequestParams} from '@ngx-ivengi/crud';
import {WarrantyService} from './warranty.service';
import {UIRouter} from '@uirouter/angular';
import {Warranty} from './warranty.model';
import {TranslateService} from '@ngx-translate/core';
import {FileService} from '../file/file.service';
import {ContactService} from '../contact/contact.service';
import {Contact} from '../contact/contact.model';
import {FilterParam} from '@ngx-ivengi/crud/request-params';
import {forkJoin} from 'rxjs/observable/forkJoin';

@Component({
  selector: 'app-warranty-form',
  templateUrl: './warranty-form.component.html'
})
export class WarrantyFormComponent extends FormComponent implements OnInit {
  public warranty: Warranty = new Warranty();
  public formTitle: string;
  public stateIdParam: string = 'warrantyId';
  public customersNoWarranty: Contact[] = [];
  public isGeneralWarrantySet: boolean = false;
  public customerContactFilter: FilterParam = {id: 0, key: 'type', operator: 'eq', value: 'CUSTOMER'};
  public requestParams = new RequestParams();

  constructor(
    protected router: UIRouter,
    private warrantyService: WarrantyService,
    protected contactService: ContactService,
    private translate: TranslateService,
    private fileService: FileService
  ) {
    super(router);
  }

  public ngOnInit(): void {
    super.ngOnInit();

    switch(this.formMode) {
      case this.FormMode.ADD: {
        this.translate.get('warranty.form.add.blockTitle').subscribe((translation) => {
          this.formTitle = translation;
        });

        this.contactService.setRoutePrefix(`assignment/${this.router.stateService.params.assignmentId}`);
        this.requestParams.addFilterParam(this.customerContactFilter);
        this.warrantyService.setRoutePrefix(`assignment/${this.router.stateService.params.assignmentId}`);
        forkJoin(
          this.contactService.getAll(this.requestParams).first(),
          this.warrantyService.getAll().first(),
        )
          .map(([contactsRes, warrantiesRes]) => {
            const warrantiesCustomerIds = warrantiesRes.map(warranty => warranty.customerId);
            const customersNoWarranty = contactsRes.filter(customer => {
              return !warrantiesCustomerIds.includes(customer.referenceId);
            });
            return { customersNoWarranty, isGeneralWarrantySet: warrantiesCustomerIds.includes('') };
          })
          .subscribe(
            result => {
              this.customersNoWarranty = result.customersNoWarranty;
              if (this.customersNoWarranty.length === 1) {
                this.warranty.customerId = this.customersNoWarranty[0].referenceId;
              }
              this.isGeneralWarrantySet = result.isGeneralWarrantySet;
            },
            err => { console.log(err); }
          );
      } break;

      case this.FormMode.UPDATE: {
        this.warrantyService.setRoutePrefix(`assignment/${this.router.stateService.params.assignmentId}`);
        this.translate.get('warranty.form.update.blockTitle').subscribe((translation) => {
          this.formTitle = translation;
        });

        this.warrantyService.get(this.router.stateService.params[this.stateIdParam]).map((warranty) => {
          warranty.setFileSrc(this.fileService.getLinkById(warranty.fileId));
          return warranty;
        }).subscribe((warranty) => {
          this.warranty = warranty;
        });
      } break;
    }
  }

  public fileChange(evt) {
    this.warranty.setFile(evt.target.files);
  }

  public save(): void {
    const currentStateParts = this.router.stateService.$current.name.split('.');
    currentStateParts.pop();
    currentStateParts.pop();
    const parentState = currentStateParts.join('.');

    switch(this.formMode) {
      case this.FormMode.ADD: {
        this.warrantyService.add(this.warranty).subscribe((result) => {
          this.router.stateService.go(parentState, this.router.stateService.params, {reload: true});
        });
      } break;

      case this.FormMode.UPDATE: {
        this.warrantyService.update(this.warranty).subscribe((result) => {
          this.router.stateService.go(parentState, this.router.stateService.params, {reload: true});
        });
      } break;
    }
  }
}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/warranty/warranty-form.component.ts